// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountPage{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.BtnBilling{
    background-color: lightgray ;
    color: black;
    border: #F4BC16 ;
}

.BtnOrder{
    background-color: transparent;
    border: 1px solid  black;
    color: black;
}
.AccountInfo{
    /* min-width: 100px; */
    /* width: auto; */
    width: 100%;
}
.AccountInfo input{

    min-width: 150px
    
}
.UpdateBTN{
    width: 50%;
}
.ChangeBTN{
    background-color:#F4BC16;
    color: black;
    border: none;
}
.AccountCard{
    /* display: unset; */
    /* width: 60%; */
    border: 1px solid;
    border-color: grey;
    border-radius: 30px;
    background-color: transparent;
}
.ContainerAccount{
    width: 100%;
    background-color: white;
    padding: 1%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;

    
}
.containerDiv{
    padding: 2%;
}
.ContainerAccount .col{
    padding: 1%;
    

}

.ChangePSW{
    justify-content: center;
    display: flex;
    flex-direction: column;
    padding: 5%;
    min-width: 300px;
    max-width: 400px;
}

.form-control:disabled{
    background-color: white !important;
}
.form-floating>.form-control:disabled~label::after, .form-floating>:disabled~label::after {
background-color: transparent !important;
}


.SwitchBtn{
    display: flex;
    flex-direction: column;
    gap: 5%;
    height: 100%;
    padding: 10%;
    border-right: 1px solid grey;
}

.form-floating>label{    z-index: 0 !important;
}


@media only screen and (max-width: 767px) {
    .DesktopPage{
        display: none;
    }
    .SwitchBtn{
        border: none;
        padding: 5%;
    }
    .BRNGeneral{
        background-color: darkgray ;
        border: black ;
        color: black;
    }
    .BtnBilling{
        background-color: lightgray ;
        color: black;
        border: #F4BC16 ;
    }
    .BtnOrder{
        background-color: transparent;
        border: 1px solid  black;
        color: black;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1050px){
    .MobilePage{display: none;}
    .card-body{
        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);;
    }
    .AccountCard{
        min-width: 700px;
    }
}
@media only screen and (min-width: 1050px) {
    .MobilePage{display: none;}
    .card-body{
        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);;
    }
    .AccountCard{
        min-width: 700px;
    }

}
@media only screen and (max-width: 768px) {
    /* .MobilePage{display: none;}
    .card-body{
        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);;
    } */
    .AccountCard{
        min-width: 350px;
    }

}

.AccountCardBody{
    padding: 0%;
}

.containerJustPSW{
    /* padding: 2%; */
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/AccountCard/AccountCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;AACf;AACA;;IAEI;;AAEJ;AACA;IACI,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;;;AAGvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;;;AAGf;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;AACA;AACA,wCAAwC;AACxC;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAChC;;AAEA,yBAAyB,qBAAqB;AAC9C;;;AAGA;IACI;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,2BAA2B;QAC3B,cAAc;QACd,YAAY;IAChB;IACA;QACI,4BAA4B;QAC5B,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,6BAA6B;QAC7B,wBAAwB;QACxB,YAAY;IAChB;AACJ;AACA;IACI,YAAY,aAAa,CAAC;IAC1B;QACI,wDAAwD;IAC5D;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,YAAY,aAAa,CAAC;IAC1B;QACI,wDAAwD;IAC5D;IACA;QACI,gBAAgB;IACpB;;AAEJ;AACA;IACI;;;OAGG;IACH;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".AccountPage{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.BtnBilling{\n    background-color: lightgray ;\n    color: black;\n    border: #F4BC16 ;\n}\n\n.BtnOrder{\n    background-color: transparent;\n    border: 1px solid  black;\n    color: black;\n}\n.AccountInfo{\n    /* min-width: 100px; */\n    /* width: auto; */\n    width: 100%;\n}\n.AccountInfo input{\n\n    min-width: 150px\n    \n}\n.UpdateBTN{\n    width: 50%;\n}\n.ChangeBTN{\n    background-color:#F4BC16;\n    color: black;\n    border: none;\n}\n.AccountCard{\n    /* display: unset; */\n    /* width: 60%; */\n    border: 1px solid;\n    border-color: grey;\n    border-radius: 30px;\n    background-color: transparent;\n}\n.ContainerAccount{\n    width: 100%;\n    background-color: white;\n    padding: 1%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 30px;\n\n    \n}\n.containerDiv{\n    padding: 2%;\n}\n.ContainerAccount .col{\n    padding: 1%;\n    \n\n}\n\n.ChangePSW{\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    padding: 5%;\n    min-width: 300px;\n    max-width: 400px;\n}\n\n.form-control:disabled{\n    background-color: white !important;\n}\n.form-floating>.form-control:disabled~label::after, .form-floating>:disabled~label::after {\nbackground-color: transparent !important;\n}\n\n\n.SwitchBtn{\n    display: flex;\n    flex-direction: column;\n    gap: 5%;\n    height: 100%;\n    padding: 10%;\n    border-right: 1px solid grey;\n}\n\n.form-floating>label{    z-index: 0 !important;\n}\n\n\n@media only screen and (max-width: 767px) {\n    .DesktopPage{\n        display: none;\n    }\n    .SwitchBtn{\n        border: none;\n        padding: 5%;\n    }\n    .BRNGeneral{\n        background-color: darkgray ;\n        border: black ;\n        color: black;\n    }\n    .BtnBilling{\n        background-color: lightgray ;\n        color: black;\n        border: #F4BC16 ;\n    }\n    .BtnOrder{\n        background-color: transparent;\n        border: 1px solid  black;\n        color: black;\n    }\n}\n@media only screen and (min-width: 768px) and (max-width: 1050px){\n    .MobilePage{display: none;}\n    .card-body{\n        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);;\n    }\n    .AccountCard{\n        min-width: 700px;\n    }\n}\n@media only screen and (min-width: 1050px) {\n    .MobilePage{display: none;}\n    .card-body{\n        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);;\n    }\n    .AccountCard{\n        min-width: 700px;\n    }\n\n}\n@media only screen and (max-width: 768px) {\n    /* .MobilePage{display: none;}\n    .card-body{\n        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);;\n    } */\n    .AccountCard{\n        min-width: 350px;\n    }\n\n}\n\n.AccountCardBody{\n    padding: 0%;\n}\n\n.containerJustPSW{\n    /* padding: 2%; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
